import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class IntegrationTelegramBotService {

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
  ) {
  }

  addTelegramBotApi(payload: any) {
    return this.http.post<any>(environment.baseURL + '/tg-bots/', payload )
      .pipe(map(v => v.data));
  }

  updateTelegramBotApi(payload: any, id: any) {
    return this.http.put<any>(environment.baseURL + `/tg-bots/update-token/${id}`, payload )
      .pipe(map(v => v.data));
  }

  getToken(channel_id: string) {
    return this.http.get<any>(environment.baseURL + `/tg-bots/token/${channel_id}`)
      .pipe(map(v => v.data));
  }

  deleteToken(id: any) {
    return this.http.delete<any>( environment.baseURL + `/tg-bots/token/${id}`)
      .pipe(map(v => v.data));
  }

}
